require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./bald-ist-es-soweit.json") })
        }
      }, "path---bald-ist-es-soweit");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---bald-ist-es-soweit!./.cache/json/bald-ist-es-soweit.json
// module id = 411
// module chunks = 231608221292675